export const convertToSnakeCase = (str: string): string => {
    return str.split(" ").join("_");
}